var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { style: _vm.outerContainerStyles }, [
    _c("span", { style: _vm.innerContainerStyles }, [
      _c("img", {
        style: _vm.imgStyles,
        attrs: { src: _vm.src, alt: _vm.alternativeText },
        on: { error: _vm.onError, load: _vm.onLoad },
      }),
      _vm.$slots.placeholder
        ? _c(
            "span",
            {
              style: {
                position: "absolute",
                top: "0",
                right: "0",
                left: "0",
                bottom: "0",
                zIndex: "0",
              },
            },
            [_vm._t("placeholder")],
            2
          )
        : _vm._e(),
      _vm.$slots.topLeft
        ? _c(
            "span",
            {
              style: { position: "absolute", top: "0", left: "0", zIndex: "2" },
            },
            [_vm._t("topLeft")],
            2
          )
        : _vm._e(),
      _vm.$slots.topRight
        ? _c(
            "span",
            {
              style: {
                position: "absolute",
                top: "0",
                right: "0",
                zIndex: "2",
              },
            },
            [_vm._t("topRight")],
            2
          )
        : _vm._e(),
      _vm.$slots.bottomLeft
        ? _c(
            "span",
            {
              style: {
                position: "absolute",
                bottom: "0",
                left: "0",
                zIndex: "2",
              },
            },
            [_vm._t("bottomLeft")],
            2
          )
        : _vm._e(),
      _vm.$slots.bottomRight
        ? _c(
            "span",
            {
              style: {
                position: "absolute",
                bottom: "0",
                right: "0",
                zIndex: "2",
              },
            },
            [_vm._t("bottomRight")],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }